import gql from 'graphql-tag'

export const getAccounts = gql`
  query($paging: PagingQuery, $order: AccountsOrder, $filter: AccountsFilter!) {
    getAccounts(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      accounts {
        id
        name
        phone
        level
        countryCode
        countryCallingCode
        extensionNumber
        otherPhone
        otherCountryCode
        otherCountryCallingCode
        otherExtensionNumber
        notes
        birthday
        billingAddressCountry
        billingAddressState
        billingAddressPostalCode
        billingAddressCity
        billingAddressStreet
        mailingAddressCountry
        mailingAddressState
        mailingAddressPostalCode
        mailingAddressCity
        mailingAddressStreet
        additionalInfoStr
        book {
          id
          name
        }
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
        recordType {
          id
          name
        }
        parentAccount {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        quotes {
          id
          name
        }
        policies {
          id
          policyName
        }
        csr {
          id
          username
        }
        caseCount
        salutation
        firstName
        middleName
        lastName
        legalName
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidateAccounts = gql`
  query($paging: PagingQuery, $filter: AccountsFilter!) {
    getAccounts(
      filter: $filter,
      paging: $paging
    ) {
      accounts {
        id
        name
        phone
        recordType {
          id
          name
        }
        source {
          id
          name
        }
      }
    }
  }
`

export const findCandidateInsureds = gql`
  query($insuredName: String!) {
    findCandidateInsureds(insuredName: $insuredName) {
        id
        name
        phone
        recordType {
          id
          name
        }
        source {
          id
          name
      }
    }
  }
`

export const getAccount = gql`
  query($accountId: Int!) {
    getAccount(
      accountId: $accountId
    ) {
      id
      name
      level
      phone
      countryCode
      countryCallingCode
      extensionNumber
      otherPhone
      otherCountryCode
      otherCountryCallingCode
      otherExtensionNumber
      notes
      birthday
      billingAddressCountry
      billingAddressState
      billingAddressPostalCode
      billingAddressCity
      billingAddressStreet
      mailingAddressCountry
      mailingAddressState
      mailingAddressPostalCode
      mailingAddressCity
      mailingAddressStreet
      additionalInfoStr
      totalPremium
      book {
        id
        name
      }
      caseCount
      updatedAt
      createdAt
      recordType {
        id
        name
      }
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      parentAccount {
        id
        name
      }
      primaryContact {
        id
        name
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      source {
        id
        name
      }
      csr {
        id
        username
      }
      certificatesOfInsurance {
        id
        coi
        revisionNumber
        policies {
          generalLiabilityPolicy {
            id
            policyName
          }
          automobilePolicy {
            id
            policyName
          }
          umbrellaExcessLiabilityPolicy {
            id
            policyName
          }
          workersCompensationPolicy {
            id
            policyName
          }
          otherPolicy {
            id
            policyName
          }
        }
      }
      salutation
      firstName
      middleName
      lastName
      legalName
    }
  }
`

export const newAccount = gql`
  mutation($contactId: Int, $accountInput: AccountInput!) {
    newAccount(
      contactId: $contactId,
      accountInput: $accountInput
    ) {
      id
      name
    }
  }
`

export const editAccount = gql`
  mutation($accountId: Int!, $accountInput: AccountInput!) {
    editAccount(
      accountId: $accountId,
      accountInput: $accountInput
    ) {
      id
    }
  }
`

export const deleteAccount = gql`
  mutation($accountId: Int!) {
    deleteAccount(
      accountId: $accountId
    )
  }
`

export const getGlobalSearchAccounts = gql`
  query($query: String!, $order: AccountsOrder!, $paging: PagingQuery!) {
    globalSearchAccounts(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      accounts {
        id
        name
        phone
        countryCode
        countryCallingCode
        extensionNumber
        otherPhone
        otherCountryCode
        otherCountryCallingCode
        otherExtensionNumber
        mailingAddress
        billingAddress
      }
    }
  }
`

export const getAllGlobalSearchAccounts = gql`
  query($query: String!, $order: AccountsOrder!, $paging: PagingQuery!) {
    globalSearchAccounts(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      accounts {
        id
        name
        phone
        countryCode
        extensionNumber
        otherPhone
        otherCountryCode
        countryCallingCode
        otherCountryCallingCode
        otherExtensionNumber
        csr {
          id
          username
        }
        book {
          id
          name
        }
        source {
          id
          name
        }
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getAccountAssets = gql`
  query($paging: PagingQuery, $order: AccountAssetsOrder, $filter: AccountAssetsFilter!, $accountId: Int!) {
    getAccountAssets(
      filter: $filter,
      order: $order,
      paging: $paging,
      accountId: $accountId,
    ) {
      accountAssets {
        id
        name
        notes
        type
        property {
          id
          address1
          address2
          city
          state
          country
          zipCode
          owner
          price
          creationTime
          buyTime
        }
        vehicle {
          id
          vid
          owner
          brand
          color
          year
          makeModel
          type
          price
          ownership
          useage
          mileage
        }
      }
    }
  }
`

export const getAccountCertificates = gql`
  query($paging: PagingQuery, $order: AccountCertificatesOrder, $filter: AccountCertificatesFilter!, $accountId: Int!) {
    getAccountCertificates(
      filter: $filter,
      order: $order,
      paging: $paging,
      accountId: $accountId,
    ) {
      accountCertificates {
        id
        name
        notes
        type
        idNumber
        ssn
        firstName
        middleName
        lastName
        licenseNumber
        expirationDate
        createdAt
        updatedAt
      }
    }
  }
`
